import { useUser } from '@r/api/auth.tsx';
import { UseWorkspace } from '@r/hooks/use-workspace.ts';
import { UseWorkspaceConfigs } from '@r/hooks/use-workspace-config.ts';

export const useWorkspaceName = () => {
  const user = useUser();
  const { workspace, isWorkspaceSuccess } = UseWorkspace(user.data);
  const workspaceConfigQuery = UseWorkspaceConfigs();

  const workspaceNameFromConfig = workspaceConfigQuery.data?.groupedConfigs?.core?.name;

  const workspaceNameFromWorkspace = isWorkspaceSuccess && workspace ? workspace.name : null;

  const workspaceName = workspaceNameFromConfig || workspaceNameFromWorkspace || '';

  const sanitizedWorkspaceName = workspaceName
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

  return {
    workspaceName,
    sanitizedWorkspaceName,
    isLoading: workspaceConfigQuery.isPending || !isWorkspaceSuccess
  };
};
